// extracted by mini-css-extract-plugin
export default {"cls1":"OTPAdminDialog-Error_cls1__SSEbl","cls2":"OTPAdminDialog-Error_cls2__N5WJ1 OTPAdminDialog-Error_cls1__SSEbl"};